export default __webpack_public_path__ + "static/media/SteelOptLogo.84e27444.png";